export const NOTIFICATOIN_OPEN = "NOTIFICATOIN_OPEN";
export const NOTIFICATOIN_CLOSE = "NOTIFICATOIN_CLOSE";